import { Organizer } from '~/modules/Organizers/Domain/Organizer'
import { GetOrganizerResponseInterface }
  from '~/modules/Organizers/Application/GetOrganizer/GetOrganizerResponseInterface'
import { repairTextEncoding } from '~/modules/Shared/Domain/Helpers/String'

interface DomainFromResponseReturn {
  organizer: Organizer
  trophyAmount: number
}

export class GetOrganizerResponseTranslator {
  public static responseFromDomain (organizer: Organizer, trophyAmount: number): GetOrganizerResponseInterface {
    return {
      id: organizer.id,
      name: organizer.name,
      avatarUrl: organizer.avatarUrl ?? null,
      logoUrl: organizer.logoUrl ?? null,
      bannerUrl: organizer.bannerUrl ?? null,
      place: organizer.place ?? null,
      trophyAmount: trophyAmount,
      brandHexColor: organizer.brandHexColor,
    }
  }

  public static domainFromResponse (response: GetOrganizerResponseInterface): DomainFromResponseReturn {
    const organizer = new Organizer(
      response.id,
      repairTextEncoding(response.name),
      response.avatarUrl,
      response.bannerUrl,
      response.logoUrl,
      null,
      response.place === null ? null : repairTextEncoding(response.place),
      response.brandHexColor
    )

    return {
      organizer: organizer,
      trophyAmount: response.trophyAmount,
    }
  }
}
